import { useState } from "react";
import "./Home.css"; // Importing external CSS file for styling
import { useNavigate } from "react-router-dom";
import { Align, Position } from "./TourNavigator_/types";
import TourHelper from "./TourHelper";
import MultiRouteTour from "./TourNavigator_/MultiRouteTour";

const images = Array(36).fill("https://marketplace.canva.com/EAFqNrAJpQs/1/0/1600w/canva-neutral-pink-modern-circle-shape-linkedin-profile-picture-WAhofEY5L1U.jpg")

const data = [
  {
    selector: '#img-0',
    data: { title: 'Title 0', description: 'Description 0' },
    align: Align.START
  },
  // {
  //   selector: '#img-1',
  //   data: { title: 'Title 1', description: 'Description 1' }
  // },
  // {
  //   selector: '#img-5',
  //   data: { title: 'Title 5', description: 'Description 5' }
  // },
  // {
  //   selector: '#img-6',
  //   data: { title: 'Title 6', description: 'Description 6' },
  //   position: Position.LEFT
  // },
  // {
  //   selector: '#img-18',
  //   data: { title: 'Title 18', description: 'Description 18' }
  // }
];

function About() {
  const [isOpen, setTourOpen] = useState(true)
  const navigate = useNavigate()

  return (
    <div className="container">
      <header id="header">
        <h1 id="title">Welcome to our Website</h1>
        <nav id="navbar">
          <ul>
            <li><a href="#" id="home-link">Home</a></li>
            <li><a href="#" id="about-link">About</a></li>
            <li><a href="#" id="contact-link">Contact</a></li>
          </ul>
        </nav>
      </header>
      
      <section id="main-content">
        <article id="article">
          <h2 id="article-title">Latest News</h2>
          <p id="article-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam sagittis mi sit amet nunc volutpat, at euismod libero fermentum.</p>
        </article>
        
        <aside id="sidebar">
          <h2 id="sidebar-title">Popular Posts</h2>
          <ul>
            <li id="post1">Post 1</li>
            <li id="post2">Post 2</li>
            {/* Add more posts here */}
          </ul>
        </aside>
      </section>
      <br />
      <br />
      <section className="gallery">
          {
            images.map((img, id) => {
              return <img key={id} src={img} id={`img-${id}`}/>
            })
          }
      </section>
      <MultiRouteTour
        id={'about'}
        isOpen
        number={2}
        steps={data}
        helper={TourHelper}
        nextStepCount={5}
        nextStepRoute="/contact"
          replace={false}
      />
    </div>
  );
}

export default About;
